import {generalQuiz} from "./quizes/generalQuiz";
import {swipeQuiz} from "./quizes/swipeQuiz";

function growtypeQuiz() {
    generalQuiz();
    swipeQuiz();
}

export {growtypeQuiz};
